var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.276,
    height: 18.086,
    viewBox: "0 0 20.276 18.086",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1208",
    "data-name": "Path 1208",
    d: "M593.315,46.4H579.794c0,.34,0,.675,0,1.009a1.145,1.145,0,0,1-1.236,1.251c-.319,0-.639-.008-.958,0a1.154,1.154,0,0,1-1.183-1.192c.019-2.942.007-5.884.011-8.826a1.4,1.4,0,0,1,.077-.441q1.085-3.185,2.18-6.367a1.71,1.71,0,0,1,1.765-1.256q6.107,0,12.213,0a1.71,1.71,0,0,1,1.76,1.263q1.088,3.17,2.171,6.341a1.652,1.652,0,0,1,.084.52c.005,2.907-.011,5.813.013,8.72a1.17,1.17,0,0,1-1.245,1.24c-.3-.015-.6,0-.9,0a1.145,1.145,0,0,1-1.23-1.23c0-.336,0-.672,0-1.029m-.931-13.547H580.726l-1.536,4.482H593.9a.292.292,0,0,0,0-.071c-.5-1.466-1-2.931-1.513-4.411m.352,10.139a1.667,1.667,0,0,0,1.705-1.663,1.691,1.691,0,1,0-3.381-.033,1.665,1.665,0,0,0,1.676,1.7m-12.391,0a1.664,1.664,0,0,0,1.7-1.667,1.691,1.691,0,1,0-3.382-.025,1.67,1.67,0,0,0,1.677,1.692",
    transform: "translate(-576.418 -30.578)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.41accda86a1966ff951642cfe524d548.svg";
export { ForwardRef as ReactComponent };